var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3669 30.25C25.9315 30.7365 25.6667 31.379 25.6667 32.0833C25.6667 33.6021 26.8979 34.8333 28.4167 34.8333C29.9355 34.8333 31.1667 33.6021 31.1667 32.0833C31.1667 30.5646 29.9355 29.3333 28.4167 29.3333C27.6022 29.3333 26.8705 29.6874 26.3669 30.25ZM26.3669 30.25L17.4167 24.9664M17.4167 24.9664C17.9793 24.4629 18.3334 23.7311 18.3334 22.9167C18.3334 22.3342 18.1523 21.794 17.8434 21.3494M17.4167 24.9664C16.9302 25.4019 16.2877 25.6667 15.5834 25.6667C14.0646 25.6667 12.8334 24.4355 12.8334 22.9167C12.8334 21.3979 14.0646 20.1667 15.5834 20.1667C16.5197 20.1667 17.3467 20.6346 17.8434 21.3494M17.8434 21.3494L26.3669 15.5833M26.3669 15.5833C26.8705 16.1459 27.6022 16.5 28.4167 16.5C29.9355 16.5 31.1667 15.2688 31.1667 13.75C31.1667 12.2312 29.9355 11 28.4167 11C26.8979 11 25.6667 12.2312 25.6667 13.75C25.6667 14.4543 25.9315 15.0968 26.3669 15.5833Z",
    stroke: "black",
    strokeWidth: 1.83333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/Share Icon.97cd0eeed54a1388ef6c7b631a331b48.svg";
export { ForwardRef as ReactComponent };